import React, { useState } from 'react';
import { View, Heading, Text, Card, Flex, Button, Badge, Divider } from '@aws-amplify/ui-react';
import { FaArrowRight, FaArrowLeft, FaMobileAlt, FaHandPointer, FaUserEdit, FaUnlockAlt, FaEnvelopeOpenText } from 'react-icons/fa';

const ManualRegistro = () => {
    const [paso, setPaso] = useState(1);

    const instrucciones = [
        {
            titulo: "Paso 1: Abrir el Menú",
            icono: <FaHandPointer size="2.5rem" color="#C5A059" />,
            texto: "Busque arriba a la derecha las 3 rayitas blancas y tóquelas para ver las opciones.",
            detalle: "Ese botón abre la lista de opciones de nuestra página.",
            ayudaVisual: "Está en la esquina superior derecha, sobre el fondo negro."
        },
        {
            titulo: "Paso 2: Ir a Registro",
            icono: <FaUserEdit size="2.5rem" color="#C5A059" />,
            texto: "En la lista que aparece, toque donde dice 'Iniciar Sesión / Registro'.",
            detalle: "Se abrirá una ventana blanca con nuestro logo arriba.",
            ayudaVisual: "Es la opción que está justo encima del cuadro rojo de Citas."
        },
        {
            titulo: "Paso 3: Sus Datos",
            icono: <FaUnlockAlt size="2.5rem" color="#C5A059" />,
            texto: "Toque 'Regístrate aquí' en letras doradas. Ponga su correo y cree una clave.",
            detalle: "Use un correo que usted pueda revisar en este momento.",
            ayudaVisual: "Está debajo del botón grande que dice 'Entrar a mi Cuenta'."
        },
        {
            titulo: "Paso 4: Verificación",
            icono: <FaEnvelopeOpenText size="2.5rem" color="#C5A059" />,
            texto: "Nosotros le enviaremos un código de 6 números al correo con el que se suscribió.",
            detalle: "Busque un mensaje enviado por Scarvaci Cloud y escriba los números aquí.",
            ayudaVisual: "Si no lo ve en su bandeja principal, busque en 'Correos no deseados'."
        }
    ];

    return (
        <View padding="2rem" backgroundColor="#f9f9f9" minHeight="100vh">
            <Flex direction="column" alignItems="center">
                
                {/* SIMULADOR DE CELULAR CON ESTÉTICA DE LA WEB REAL */}
                <Card 
                    variation="elevated"
                    width="360px" 
                    height="680px" 
                    borderRadius="40px" 
                    border="12px solid #1a1a1a"
                    backgroundColor="white"
                    style={{ position: 'relative', overflow: 'hidden', boxShadow: '0px 20px 40px rgba(0,0,0,0.3)' }}
                >
                    {/* ENCABEZADO SIMULADO (Imitando image_0568ff.png) */}
                    <View backgroundColor="#000" padding="15px">
                        <Flex justifyContent="space-between" alignItems="center">
                            <View>
                                <Text color="#C5A059" fontSize="0.7rem" fontWeight="bold">Giovanni Scarvaci &</Text>
                                <Text color="#C5A059" fontSize="0.7rem" fontWeight="bold">Asociados</Text>
                            </View>
                            {/* Icono de hamburguesa simulado */}
                            <View border="1px solid white" padding="2px" borderRadius="3px">
                                <View width="15px" height="2px" backgroundColor="white" marginBottom="2px" />
                                <View width="15px" height="2px" backgroundColor="white" marginBottom="2px" />
                                <View width="15px" height="2px" backgroundColor="white" />
                            </View>
                        </Flex>
                    </View>

                    {/* Contenido de la Guía */}
                    <View padding="1.5rem" height="100%" style={{ overflowY: 'auto' }}>
                        <Badge variation="info" marginBottom="1rem" backgroundColor="#C5A059" color="black">GUÍA PARA SU CELULAR</Badge>
                        <Heading level={4} marginBottom="0.5rem" color="#111">
                            ¿Cómo registrarse paso a paso?
                        </Heading>
                        
                        <Divider marginBottom="1.5rem" />

                        <Flex direction="column" alignItems="center" textAlign="center" gap="1rem">
                            <View padding="10px" backgroundColor="#fdfbf4" borderRadius="50%">
                                {instrucciones[paso - 1].icono}
                            </View>
                            
                            <Heading level={5} color="#C5A059">{instrucciones[paso - 1].titulo}</Heading>
                            
                            <Text fontSize="1.1rem" fontWeight="600" color="#333" lineHeight="1.4">
                                {instrucciones[paso - 1].texto}
                            </Text>

                            <View backgroundColor="#eef6ff" padding="12px" borderRadius="8px" border="1px solid #adcfff">
                                <Text fontSize="0.9rem" color="#0056b3">
                                    <b>Lo que verá:</b> {instrucciones[paso - 1].ayudaVisual}
                                </Text>
                            </View>

                            <View backgroundColor="#fff8e1" padding="12px" borderRadius="8px" border="1px dashed #C5A059">
                                <Text fontSize="0.85rem" color="#856404">
                                    <b>Nota importante:</b> {instrucciones[paso - 1].detalle}
                                </Text>
                            </View>
                        </Flex>

                        {/* Botones de Navegación del Manual */}
                        <Flex justifyContent="space-between" marginTop="2.5rem" paddingBottom="4rem">
                            <Button 
                                disabled={paso === 1} 
                                onClick={() => setPaso(paso - 1)}
                                size="small"
                                variation="link"
                                color="#666"
                            >
                                <FaArrowLeft /> Atrás
                            </Button>
                            
                            <Text fontWeight="bold" fontSize="1.1rem" color="#C5A059">{paso} / 4</Text>

                            <Button 
                                disabled={paso === 4} 
                                onClick={() => setPaso(paso + 1)}
                                size="small"
                                variation="primary"
                                backgroundColor="#C5A059"
                                border="none"
                            >
                                {paso === 4 ? "¡Terminar!" : "Siguiente"} <FaArrowRight />
                            </Button>
                        </Flex>
                    </View>

                    {/* Botón Home físico del simulador */}
                    <View 
                        style={{ 
                            position: 'absolute', bottom: '10px', left: '50%', 
                            transform: 'translateX(-50%)', width: '35px', 
                            height: '35px', border: '2px solid #444', borderRadius: '50%',
                            backgroundColor: '#222'
                        }} 
                    />
                </Card>

                <Flex direction="column" alignItems="center" marginTop="1.5rem">
                    <Text color="#666" fontStyle="italic">
                        <FaMobileAlt style={{marginRight: '5px'}} /> Toque <b>Siguiente</b> para ver cómo continuar.
                    </Text>
                </Flex>
            </Flex>
        </View>
    );
};

export default ManualRegistro;